var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDomain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 32.4,
    viewBox: "0 0 36 32.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-domain",
    "data-name": "Icon material-domain",
    d: "M21,11.7V4.5H3V36.9H39V11.7ZM10.2,33.3H6.6V29.7h3.6Zm0-7.2H6.6V22.5h3.6Zm0-7.2H6.6V15.3h3.6Zm0-7.2H6.6V8.1h3.6Zm7.2,21.6H13.8V29.7h3.6Zm0-7.2H13.8V22.5h3.6Zm0-7.2H13.8V15.3h3.6Zm0-7.2H13.8V8.1h3.6Zm18,21.6H21V29.7h3.6V26.1H21V22.5h3.6V18.9H21V15.3H35.4ZM31.8,18.9H28.2v3.6h3.6Zm0,7.2H28.2v3.6h3.6Z",
    transform: "translate(-3 -4.5)",
    fill: "#74ad85"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomain);
export default __webpack_public_path__ + "static/media/domain.469a0af8.svg";
export { ForwardRef as ReactComponent };